import React, { useState, useEffect } from 'react';
import { 
    Descricoes,
    ContainerD,
    CTituloLinha,
    DSubtitulo,
    DTL,
    DTLDescricao,
    CardListD,
    CardD,
    TituloD,
    DescricaoD
} from './Home.style.js';
import Icon1 from '../components/svg/icon1.svg';
import Icon2 from '../components/svg/icon2.svg';
import Icon3 from '../components/svg/icon3.svg';
import DadosAPI from '../examples/modelo_api_home.json'

function DescricoesPage({Item}) {


    const descricoes1 = DadosAPI.dados.descricoes;

    const cardD = DadosAPI.dados.cardIcones.icones;

    return (
        <Descricoes style={{background: Item.itembackground}}>
            <ContainerD>
                <CTituloLinha>
                    <DSubtitulo>{DadosAPI.dados.descricoes.subtitulo}</DSubtitulo>
                    <DTL style={{color: Item.itemcolor}}>{DadosAPI.dados.descricoes.titulo}</DTL>
                    <DTLDescricao>{DadosAPI.dados.descricoes.descricao}</DTLDescricao>
                </CTituloLinha>
                <CardListD>
                    {cardD.map((section) => (
                        <CardD key={section.id}>
                            <img style={{width:50, height:50}} src={section.icone}/>
                            <TituloD style={{color: descricoes1.cor}}>{section.titulo}</TituloD>
                            <DescricaoD style={{ whiteSpace: 'pre-line' }}>{section.descricao}</DescricaoD>
                        </CardD>
                    ))}
                </CardListD>
            </ContainerD>
        </Descricoes>
    );
}

export default DescricoesPage;
